<template>
  <div v-if="!isLoading" class="home__wrapper">
    <Header></Header>
    <Navbar />
    <div class="home">
      <div class="home__banner">
        <Banner :dataBanner="dataBanner"></Banner>
      </div>
      <div class="home__result main-container">
        <Title class="title-container__title-custom" :title="getTranslatedText('latest results')" />

        <div class="home__result--item" v-for="(item, index) in dataResult" :key="index">
          <span>{{ getTranslatedText(item.gameName) }}</span>
          <span>{{ renderDateTimeText(item.drawDate) }}</span>
          <span @click="handleViewResult(item.gameSlug)">{{ getTranslatedText('view results') }}</span>
          <div class="home__result--item_number">
            <Number v-for="(n, i) in item.numbers" :key="i" :number="n.value" :bgColor="n.color_code" />
            <div class="bonus-number" v-if="item.bonusNumer.length > 0">
              <Number v-for="(n, i) in item.bonusNumer" :key="i" :number="n.value" :bgColor="n.color_code" />
            </div>
          </div>
        </div>
        <EmptyComponent v-if="dataResult.length == 0" :description="getTranslatedText('empty lastest result')" />
      </div>
    </div>
    <FreeBetPopup />
    <div style="padding:10px">
      <HomeFooterButton />
    </div>
    <div class="clock">
      <Clock textColor="#333" containerColor="#fff" />
    </div>
  </div>
  <div class="loading-container" v-else>
    <Loading />
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Banner from "@/components/banner";
import Number from "@/components/common/number";
import HomeService from "@/services/home/index.service.ts";
import Loading from "@/components/common/loading/loading.vue";
import Header from '@/components/header';
import Title from "@/components/common/title";
import EmptyComponent from '@/components/common/empty';
import { notifyApiError } from "@/utils/notify";
import Clock from "@/components/common/Clock.vue";
import HomeFooterButton from "@/components/common/HomeFooterButton.vue";
import Navbar from "@/components/common/header/navbar.vue";
import PromotionsService from "@/services/promotions/index.service";
import FreeBetPopup from "@/components/free-bets/index.vue";

export default {
  mixins: [languageMixins, utilsMixins],
  components: { Header, Banner, Number, Loading, EmptyComponent, Title, Clock, HomeFooterButton, Navbar, FreeBetPopup },
  data() {
    return {
      isLoading: false,
      dataBanner: [],
      dataResult: [],
      intervalTimer: [],
    };
  },
  created() {
    this.fetchData();
    this.$store.commit("setMarketSelected", null);
  },
  watch: {
    "$store.state.nextDraws"() {
      const games = this.$store.state.gameMarket;
      if (games?.length && this.$store.state.gameSettings?.gameSetting) {
        this.collectDataBanner(games);
      }
    },
    "$store.state.gameSettings"() {
      const games = this.$store.state.gameMarket;
      if (games?.length && this.$store.state.gameSettings?.gameSetting) {
        this.collectDataBanner(games);
      }
    },
  },
  unmounted() {
    if (this.intervalTimer.length > 0) {
      this.intervalTimer.forEach(item => clearInterval(item));
    }
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        let res;
        res = await HomeService.getGameMarket();
        if (res.status === 'success') {
          this.collectDataBanner(res.result);
          this.$store.commit('SET_GAME_MARKET', res.result);
        }

        res = await HomeService.getLastestResults();
        if (res.status === 'success') {
          this.dataResult = this.handleRenderNumbers(res.result);
          this.handleGetLastestResultsAfterMinutes();
        }

        this.checkPromotions();

        this.getCustomerPromoStatus();

      } catch (error) {
        notifyApiError(error);
      } finally {
        this.isLoading = false;
      }
    },


    collectDataBanner(data) {
      if (!data) return;
      const config = this.$store.state.gameSettings?.gameSetting;
      if (!config) return;
      const drawDates = this.$store.state.nextDraws || [];
      this.dataBanner = data.map(game => {
        const drawDatesAllowSlug = drawDates.find(x => x.slug == game.slug) || {};
        const draws = drawDatesAllowSlug.draws || [];
        const drawDate = draws.length > 0 && draws.filter(x => this.compareDate(x.draw_date, new Date()) >= 0);
        const gameConfig = config[game.slug] || {};

        return {
          id: game.id,
          name: game.name,
          slug: game.slug,
          game_type_name: game.game_type_name,
          banner: gameConfig.banner,
          banner_mobile: gameConfig.bannerMobile,
          drawDate: drawDate && drawDate.length > 0 && drawDate[0].draw_date,
          drawDate1: game.slug === 'uk49s' && drawDate && drawDate.length > 1 ? drawDate[1].draw_date : null
        };
      });
    },

    handleRenderNumbers(data) {
      const gameNumbers = this.$store.state.gameMarket;
      return data.map(lr => {
        let numbers = gameNumbers.find(x => x.slug == lr.game_slug)?.balls;
        let results = lr.draws[0].results;
        return {
          gameSlug: lr.game_slug,
          gameName: lr.game_name,
          drawDate: lr.draws[0].draw_date,
          numbers: this.filterAndSortNumbers(numbers, results[0]),
          bonusNumer: numbers.filter((item) => results[1] && results[1].includes(item.value))
        }
      })
    },

    handleViewResult(gameSlug) {
      if (!gameSlug) return;
      const query = this.$route.query;
      this.$router.push({ path: `/lastest-results/`, query });
      this.$store.commit("setGameSlug", gameSlug)
    },

    handleGetLastestResultsAfterMinutes() {
      this.intervalTimer.push(setInterval(async () => {
        try {
          let res = await HomeService.getLastestResults();
          if (res.status === 'success') {
            this.dataResult = this.handleRenderNumbers(res.result)
          }
        } catch (error) {
          notifyApiError(error);
        }

      }, 60000))
    },

    async checkPromotions() {
      try {
        let res = await PromotionsService.getPromos();
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomerPromoStatus() {
      try {
        let res = await PromotionsService.checkCustomerPromos();
        if(res.result.count){
          this.$store.commit("setFreeBetCount", res.result.count)
        } else {
          this.$store.commit("setFreeBetCount", 0)
          // Clear localStorage when count is 0 to allow popup to show again when user gets new free bets
          localStorage.removeItem('showPromoPopUp');
        }
      } catch (error) {
        console.log(error);
      }
    },

  }
};
</script>

<style lang="scss">
@import "@/public/scss/home/_index.scss";

.clock {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
